<script setup>
import {ref, onBeforeMount, reactive} from "vue";
import YTTransfer from "@/components/YTTransfer/index.vue"
import {detailTagGroupTagPool, editTagGroupTagPool} from "@/api/tag/tag.js";
import {getRoute} from "@/hooks/getRoute.js";
import {editTagGroup} from "@/api/tagGroup/tagGroup.js";
const route = getRoute().route
onBeforeMount(async () => {
  if (!route.query.tagGroupId) {
    hasTagGroupId.value = false
    return ElMessage.error("暂无标签信息")
  }
  isEdit.value = true
  await getDetail()
})

// 是否为编辑模式
const isEdit = ref(false)
// 是否拥有标签组id
const hasTagGroupId = ref(true)

// 加载状态
const loading = ref(false)
// 获取分组信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await detailTagGroupTagPool(route.query.tagGroupId)
    console.log("res", res)
    groupsInfo.value = res.tagGroup
    selected.value = res.selectedPool
    unselected.value = res.unselectedPool
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 标签分组信息
const groupsInfo = ref()

/*穿梭框相关功能*/
// 已选标签
const selected = ref([])
// 未选标签
const unselected = ref([])
// 处理添加标签
const handleAddTag = async (info) => {
  try {
    loading.value = true
    let param = {
      tagGroupId: route.query.tagGroupId,
      tagIdList: info
    }
    await editTagGroupTagPool(param)
    ElMessage.success("添加成功")
    await getDetail()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理移除标签
const handleRemoveTag = async (info) => {
  try {
    loading.value = true
    let param = {
      tagGroupId: route.query.tagGroupId,
      tagIdList: info
    }
    await editTagGroupTagPool(param)
    ElMessage.success("移除成功")
    await getDetail()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*弹窗相关*/
// 弹窗表单锚点
const dialogFormRef = ref()
// 弹窗表单
const dialogForm = reactive({
  tagGroupId: null,
  tagGroupName: null,
  tagGroupNameEn: null,
  tagGroupNameChange: null,
  tagGroupNameEnChange: null,
  applicationReason: null,
})
// 处理编辑标签分组名称
const handleEdit = () => {
  open.value = true
  console.log("groupsInfo.value", groupsInfo.value)
  dialogForm.tagGroupId = groupsInfo.value.id
  dialogForm.tagGroupName = groupsInfo.value.name
}
// 标签名称校验规则
const checkTagGroupName = (rule, value, callback) => {
  if (!dialogForm.tagGroupNameChange) {
    return callback(new Error("标签组名称（中文）不能为空！"))
  }
  if (!dialogForm.tagGroupNameEnChange) {
    return callback(new Error("标签组名称（English）不能为空！"))
  }
  return callback()
}
// 弹窗表单校验规则
const dialogRules = {
  tagGroupName: [
    {required: true, validator: checkTagGroupName, trigger: "blur"}
  ],
  applicationReason: [
    {required: true, message: "请填写原因", trigger: "blur"}
  ]
}
// 关闭新增分组弹窗表单
const closeDialog = () => {
  open.value = false
  dialogForm.tagGroupId = null
  dialogForm.tagGroupName = null
  dialogForm.tagGroupNameEn = null
  dialogForm.tagGroupNameChange = null
  dialogForm.tagGroupNameEnChange = null
  dialogForm.applicationReason = null
  groupNameTab.value = "zh"
  dialogFormRef.value.clearValidate()
}
// 提交编辑分组表单
const submitDialog = async () => {
  try {
    loading.value = true
    let param = {
      tagGroupId: dialogForm.tagGroupId,
      tagGroupName: dialogForm.tagGroupNameChange,
      tagGroupNameEn: dialogForm.tagGroupNameEnChange,
      applicationReason: dialogForm.applicationReason
    }
    await editTagGroup(param)
    ElMessage.success("修改分组名称成功，请等待审核。")
    closeDialog()
    await handleSearch()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建分组弹窗打开状态
const open = ref(false)
/*中英文切换输入框相关Tab*/
// 商品分组组tab
const groupNameTab = ref("zh")
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="ytCard_box flex_left">
      <div class="ytCard_title_box flex_left">
        <div class="ytCard_title_line"></div>
        <div class="ytCard_title" v-text="`标签分组名称：${groupsInfo?.name}`" ></div>
        <div>
          <v-btn color="#796cb4" :disabled="!hasTagGroupId || groupsInfo?.state !== 3" @click="handleEdit">
            修改分组名称
          </v-btn>
        </div>
      </div>
    </div>
    <div class="flex_center flex_left mg_l_2" v-loading="loading">
      <YTTransfer ref="YTTransferRef" :disabled="!hasTagGroupId || groupsInfo?.state === 3 || groupsInfo?.state === 2" :isSecond="false" :selected="selected" :unselected="unselected" @to-left="handleRemoveTag" @to-right="handleAddTag"></YTTransfer>
    </div>
  </div>
  <el-dialog
      v-model="open"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">编辑标签</div>
    </template>
    <el-form
        ref="dialogFormRef"
        style="max-width: 100%;"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="loading"
        id="dialogForm"
    >
      <div class="mg_b_2" v-if="isEdit" style="text-align: left">
        标签组名称：{{dialogForm.tagGroupName}}
      </div>
      <el-form-item label="标签名称更改：" prop="tagGroupName" v-if="isEdit">
        <el-tabs
            v-model="groupNameTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <el-input show-word-limit maxlength="12" v-model="dialogForm.tagGroupNameChange" placeholder="请勿超过12个字符"></el-input>
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <el-input show-word-limit maxlength="40" v-model="dialogForm.tagGroupNameEnChange" placeholder="Do not exceed 40 characters"></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item label="申请原因：" prop="applicationReason" v-if="isEdit">
        <el-input show-word-limit maxlength="20" v-model="dialogForm.applicationReason" placeholder="请填写原因，20个字符内"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">提交</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.ytCard_box {
  width: 100%;
  text-align: left;
  margin-bottom: 24px;
  padding: 20px 0 0 20px;
  .ytCard_title_box {
    margin-bottom: 20px;
    box-sizing: border-box;
    .ytCard_title_line {
      width: 4px;
      height: 32px;
      background: #796CB4;
      border-radius: 2px;
      margin-right: 15px;
    }
    .ytCard_title {
      margin-right: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #000000;
    }
  }
}
</style>
